import $ from 'jquery';
// import { breakpoints } from './_site';
import { create as createSlider } from './slider';

export const create = ($el) => {
    // main banner
    createSlider($el, {
        fade: true,
        draggable: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: true,
        autoplaySpeed: 4000,
        lazyLoad: 'ondemand',
        responsive: [
            // {
            //     breakpoint: breakpoints.md,
            //     settings: {
            //         draggable: true
            //     }
            // },
            // {
            //     breakpoint: breakpoints.sm,
            //     settings: {
            //         draggable: true,
            //         dots: true,
            //         fade: true
            //     }
            // },
            // {
            //     breakpoint: breakpoints.xs,
            //     settings: {
            //         draggable: true,
            //         dots: true,
            //         fade: true
            //     }
            // }
        ],
        customPaging: function(slider, i) {
            let slide = slider['$slides'][i],
                dotTitle = slide.getAttribute('data-dot-title'),
                $container = $(
                    '<div class="banner-slider__dot-container"></div>'
                ),
                $title = $(
                    `<span class="banner-slider__dot-text">${dotTitle}</span>`
                ),
                $button = $(
                    '<button class="banner-slider__dot" type="button" data-role="none" role="button" tabindex="0" />'
                );

            $container.append($button);
            $container.append($title);

            return $container;
        },
    });

    // $el.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    //     changeBg($el, event, slick, currentSlide, nextSlide);
    // });
    // changeBg($el, '', '', 0, 0);
};
export const changeBg = ($el, event, slick, currentSlide, nextSlide) => {
    var $bg = $el.children('.slider__bg'),
        $item = $el
            .find('.slider__item')
            .not('.slick-cloned')
            .eq(nextSlide),
        bgImage = $item.data('bg-image'),
        bgRepeat = $item.data('bg-repeat'),
        color1 = $item.data('bg-color-1') || '',
        color2 = $item.data('bg-color-2');

    // stop multiple calls
    if ($el.data('timeout')) {
        clearTimeout($el.data('timeout'));
    }
    $el.data(
        'timeout',
        setTimeout(function() {
            var oldProps;

            // add new div for bg
            if (!$bg.length) {
                $bg = $('<div class="slider__bg" />');
                $el.prepend($bg);
            } else {
                // keep old props
                oldProps = $bg.css(['background-image', 'background-color']);
                $el.css({
                    backgroundImage: oldProps['background-image'],
                    backgroundColor: oldProps['background-color'],
                });
            }
            // image
            if (bgImage) {
                if (color1) {
                    $bg.css('background-color', color1);
                }
                if (bgRepeat) {
                    $bg.css({
                        backgroundRepeat: 'repeat',
                        backgroundSize: 'auto',
                    });
                } else {
                    $bg.css({
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                    });
                }
                $bg.hide()
                    .css('background-image', 'url(' + bgImage + ')')
                    .fadeIn(300);
            }
            // only colors
            else {
                if (color2) {
                    $bg.hide()
                        .css(
                            'background-image',
                            'linear-gradient(' + color1 + ', ' + color2 + ')'
                        )
                        .fadeIn(300);
                } else {
                    $bg.hide()
                        .css({
                            backgroundColor: color1,
                            backgroundImage: 'none',
                            backgroundRepeat: 'repeat',
                            backgroundSize: 'auto',
                        })
                        .fadeIn(300);
                }
            }
        }, 100)
    );
};
export const binds = () => {
    create($('.banner-slider'));
};
